<template>
  <div class="wrap">
    <div class="p-t-md">
      <div class="container">
        <div class="row">
          <div class="col-xs-12">
            <h1 class="title">测评中心</h1>
            <div class="b-b"></div>
          </div>
        </div>
        <loading v-if="loading === 1"></loading>
        <div class="row" v-if="loading === 0">
          <div class="col-xs-12 col-md-3 m-t-md" v-for="evaluate in evaluates" :key="evaluate._id" @click="show(evaluate)">
            <div class="questionnaire">
              <div class="plot" :style="{'background-image':'url(' + evaluate.plot +')'}">
              </div>
              <div class="name">
                {{evaluate.name}}
              </div>
              <div class="desc">
                <span class="num">{{evaluate.evaluate_num}}</span>人参与测评
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Evaluate from "../../resource/evaluate";
import Loading from "../blocks/loading.vue";
export default {
  name: "EvaluateList",
  data: function() {
    return {
      loading: 1,
      evaluates: []
    };
  },
  computed: {
    ...mapGetters({ user: "loginUser" })
  },
  created: function() {
    let that = this;
    Evaluate.questionnaires({}).then(
      res => {
        let data = res.body;
        if (data.code === 0) {
          that.evaluates = data.result;
          that.loading = 0;
        } else {
          alert(data.msg);
        }
      },
      res => {}
    );
  },
  mounted: function() {
    document.title = "测评中心";
    const that = this;
    if (that.user && that.user.category === 2) {
      that.$router.replace("/company");
    }
  },
  methods: {
    show: function(evaluate) {
      let that = this;
      that.$router.push(`/evaluate/${evaluate._id}`);
    }
  },
  components: { Loading }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">

</style>



// WEBPACK FOOTER //
// list.vue?5fe96adc